import PastIntervalSelector from 'components/elements/PastIntervalSelect';
import WithLabel from 'components/elements/WithLabel';
import { useDateUpdatedFilter } from 'state/filterDocuments';

const DateUpdatedFilter = () => {
  const { dateUpdatedFilter, setDateUpdatedFilter } = useDateUpdatedFilter();

  return (
    <WithLabel label="Date Updated">
      <PastIntervalSelector value={dateUpdatedFilter} onChange={setDateUpdatedFilter} />
    </WithLabel>
  );
};

export default DateUpdatedFilter;
